'use strict';

import Handlebars from 'injectify/runtime';
import {CurrencyUtils} from '../utils/CurrencyUtils';

Handlebars.registerHelper('currencyWithUnitString', function (currency, unit) {

    return CurrencyUtils.getCurrencyWithUnitString(currency, unit);
});

Handlebars.registerHelper('json', function(context) {
    return JSON.stringify(context);
});


// WEBPACK FOOTER //
// ./shared/helper/currency.js